var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3145 3.0003C17.5771 2.73766 17.8889 2.52932 18.2321 2.38718C18.5752 2.24503 18.943 2.17188 19.3145 2.17188C19.6859 2.17187 20.0537 2.24503 20.3968 2.38718C20.74 2.52932 21.0518 2.73766 21.3145 3.0003C21.5771 3.26295 21.7854 3.57475 21.9276 3.91791C22.0697 4.26107 22.1429 4.62887 22.1429 5.0003C22.1429 5.37174 22.0697 5.73953 21.9276 6.08269C21.7854 6.42585 21.5771 6.73766 21.3145 7.0003L7.81445 20.5003L2.31445 22.0003L3.81445 16.5003L17.3145 3.0003Z",
    stroke: "#55575A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.1a93925b73d22ec02d4d95eddf875124.svg";
export { ForwardRef as ReactComponent };